/**
 * 预加载图片
 * @param {string[]} srcs - 图片的URL数组
 * @param {number} maxConcurrency - 最大并发数
 * @returns {Promise<boolean[]>} - 每个图片加载成功返回true，否则返回false
 */
export const preloadImages = async (
  srcs: string[],
  maxConcurrency = Infinity
): Promise<boolean[]> => {
  const results: boolean[] = []
  const promises: Promise<boolean>[] = []

  for (const src of srcs) {
    promises.push(
      new Promise(resolve => {
        const img = new Image()
        img.src = src
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
      })
    )
  }

  for (let i = 0; i < maxConcurrency && i < promises.length; i++) {
    results.push(await promises[i])
  }

  return results
}
